const pct = (v) => (v == null ? "—" : `${v}%`);
const money = (v) => `$${Number(v).toLocaleString("es-MX", { maximumFractionDigits: 2 })}`;

const Card = ({ label, value, sub, testid }) => (
  <div data-testid={testid} className="c-card p-3.5">
    <p className="text-[11px] c-muted leading-tight">{label}</p>
    <p data-testid={`${testid}-value`} className="font-heading text-2xl font-extrabold tracking-tight mt-0.5">{value}</p>
    {sub && <p className="text-[11px] c-text-2">{sub}</p>}
  </div>
);

export const MetricCards = ({ m }) => (
  <div className="grid grid-cols-2 gap-2" data-testid="admin-metric-cards">
    <Card testid="metric-activos-hoy" label="Usuarios activos hoy" value={m.uso?.activos_hoy ?? 0} />
    <Card testid="metric-activos-7d" label="Usuarios activos en 7 días" value={m.uso?.activos_7d ?? 0} />
    <Card testid="metric-minutos-promedio" label="Minutos promedio por usuario activo (semana)" value={m.uso?.minutos_promedio_7d ?? "—"} />
    <Card testid="metric-invitaciones" label="Invitaciones enviadas" value={m.invitaciones_enviadas} />
    <Card testid="metric-registros" label="Registros" value={m.registros} sub={`Tasa de registro ${pct(m.tasa_registro)}`} />
    <Card testid="metric-activados" label="Activados" value={m.activados} sub={`Tasa de activación ${pct(m.tasa_activacion)}`} />
    <Card testid="metric-fundadores" label="Fundadores" value={`${m.fundadores.asignados} de ${m.fundadores.cupo}`} />
    <Card testid="metric-compartibles" label="Compartibles promedio por activado" value={m.compartibles_promedio ?? "—"} />
    <Card testid="metric-busquedas" label="Búsquedas en red" value={m.busquedas.total} sub={`${pct(m.busquedas.porcentaje)} con resultado`} />
    <Card testid="metric-solicitudes" label="Solicitudes creadas" value={m.solicitudes.total}
      sub={`${pct(m.solicitudes.porcentaje)} atendidas · ${m.solicitudes.tiempo_promedio_horas != null ? `${m.solicitudes.tiempo_promedio_horas} h promedio` : "sin respuestas"}`} />
    <Card testid="metric-referidos" label="Referidos de la red" value={m.referidos.creados} sub={`${m.referidos.cerrados} cerrados`} />
    <div data-testid="metric-cerrados-moneda" className="col-span-2 c-card p-3.5 space-y-1">
      <p className="text-[11px] c-muted">Referidos cerrados por moneda (sin conversión)</p>
      {m.referidos.por_moneda.length === 0 ? <p className="text-sm c-text-2">Ninguno todavía.</p> : m.referidos.por_moneda.map((r) => (
        <p key={r.moneda} data-testid={`metric-cerrados-${r.moneda}`} className="text-sm"><span className="font-semibold">{r.moneda}</span> · {r.cantidad} · negocio {money(r.monto_negocio)} · comisión {money(r.comision)}</p>
      ))}
    </div>
  </div>
);

export const PendingList = ({ items }) => (
  <div data-testid="admin-pending-list" className="c-card p-3.5 space-y-2">
    <p className="font-mono text-[10px] tracking-[0.2em] uppercase c-muted">Registrados sin activar</p>
    {items.length === 0 ? <p className="text-sm c-text-2">Nadie pendiente.</p> : items.map((p) => (
      <div key={p.id} data-testid="admin-pending-item" className="flex items-center gap-2 text-sm">
        <span className="flex-1 min-w-0"><span className="font-semibold">{p.nombre}</span><span className="block text-xs c-muted truncate">Invitó: {p.invitador || "—"}</span></span>
        <span className="text-xs font-semibold">{p.conteo} de {p.meta}</span>
        <span className="text-xs c-muted w-14 text-right">{p.dias} día{p.dias === 1 ? "" : "s"}</span>
      </div>
    ))}
  </div>
);
